import React from 'react';
import PropTypes from 'prop-types';

import { useImageLoader } from '../hooks';

const BackgroundImageLoader = props => {
    const {
        tagName: TagName,
        className,
        style,
        src,
        placeholderSrc,
        placeholderClassName,
        fallbackSrc,
        fallbackClassName,
        loadedClassName,
        children,
        ...otherProps
    } = props;
    const [isLoaded, error] = useImageLoader(src);
    let currentSrc = placeholderSrc;
    let currentClassName = className + ' ' + placeholderClassName;

    if (isLoaded) {
        currentSrc = src;
        currentClassName = className + ' ' + loadedClassName;
    } else if (error) {
        currentSrc = fallbackSrc;
        currentClassName = className + ' ' + fallbackClassName;
    }

    return (
        <TagName
            {...otherProps}
            className={currentClassName}
            style={{
                ...style,
                backgroundImage: currentSrc ? `url(${currentSrc})` : ''
            }}>
            {isLoaded && children}
        </TagName>
    );
};

BackgroundImageLoader.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    src: PropTypes.string,
    placeholderSrc: PropTypes.string,
    placeholderClassName: PropTypes.string,
    fallbackSrc: PropTypes.string,
    fallbackClassName: PropTypes.string,
    loadedClassName: PropTypes.string
};
BackgroundImageLoader.defaultProps = {
    tagName: 'div'
};

export default BackgroundImageLoader;
